import { Children, ReactNode, HTMLAttributes, forwardRef } from "react";

export type Props = HTMLAttributes<HTMLDivElement> & {
  /** Two children elements to display in columns */
  children: ReactNode;
  /** Additional CSS classes */
  className?: string;
  /** Additional CSS classes for left column */
  leftClassName?: string;
  /** Additional CSS classes for right column */
  rightClassName?: string;
  /** Test ID for testing */
  "data-testid"?: string;
};

/**
 * Base two-column layout component with no styling.
 * Splits children into left and right columns.
 */
export const TwoColumnsLayoutBase = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      className,
      leftClassName,
      rightClassName,
      "data-testid": testId = "two-columns-layout-base",
      ...props
    },
    ref
  ) => {
    const [left, right] = Children.toArray(children);

    return (
      <div ref={ref} className={className} data-testid={testId} {...props}>
        <div className={leftClassName} data-testid={`${testId}-left`}>
          {left}
        </div>
        <div className={rightClassName} data-testid={`${testId}-right`}>
          {right}
        </div>
      </div>
    );
  }
);

TwoColumnsLayoutBase.displayName = "TwoColumnsLayoutBase";

export default TwoColumnsLayoutBase;

